// 使用sessionStorage和localStorage缓存
import {session, local} from './storage'
const cache = {
  /**
   * 缓存到sessionStorage中的数据
   */
  // 登录信息
  setLoginInfo(data) {
    session.set('loginInfo', data);
  },
  getLoginInfo() {
    return session.get('loginInfo');
  },
  getOpenId() {
    const loginInfo = this.getLoginInfo();
    return loginInfo && loginInfo.openId || '';
  },
  // 绑定状态
  setBindingState(state) {
    session.set('bindingState', state);
  },
  getBindingState() {
    return session.get('bindingState');
  },

  // 用户列表
  setLoginUserList(data) {
    session.set('LoginUserList', data);
  },
  getLoginUserList() {
    return session.get('LoginUserList');
  },
  // 保存yoyo环境绑定微信时的状态
  setWxBinDing(state = false) {
    session.set('wxBinDing', state);
  },
  getWxBinDing() {
    return session.get('wxBinDing')
  },
  /**
   * 缓存到localStorage中的数据
   */
  // 已使用的微信授权code
  setUsedWxCode(data) {
    local.set('usedWxCode', data);
  },
  getUsedWxCode() {
    return local.get('usedWxCode');
  },
  getUsedWxCodeCookie() {
    return local.get('usedWxCode');
  },
  setIs365() {
    session.set('is365', '1');
  },
  is365() {
    return session.get('is365') == 1;
  },
  setLogined() {
    session.set('isLogined', 1);
  },
  isLogined() {
    return session.get('isLogined') == 1;
  },
};

export default cache;